import { Trans } from '@lingui/macro'

import * as React from 'react'

import { Box, Grid, GridCentered } from '~ui/components/layout/Box'
import { SpeedloFooter } from '~ui/components/speedloFooter/SpeedloFooter'
import { getGridPlacement } from '~ui/utils/gridUtils'

import { IllustrationsAttribution } from './IllustrationsAttribution'

type TProps = NoChildren & {
  isMobile: boolean
  isMinimal: boolean
}

/**
 * Footer base component used in the footer of the app.
 * It has been separated from the footer component in order to extract the minimal footer without having to load the context.
 * Now we can use ShopSpeedloFooterMinimal component without reading context of available branches.
 */
export const FooterBase: React.FC<TProps> = ({ isMobile, isMinimal }) => {
  return (
    <GridCentered
      {...getGridPlacement({ col: `all` })}
      gridTemplateColumns={`1fr max-content 1fr`}
      rowGap={`large`}
    >
      {/* ILLUSTRATIONS ATTRIBUTION above speedlo logo on mobile */}
      {isMinimal && isMobile && (
        <Grid {...getGridPlacement({ col: `all` })}>
          <IllustrationsAttribution />
        </Grid>
      )}

      <Box />
      <SpeedloFooter speedloFooterLabel={<Trans>Powered by</Trans>} />

      {/* ILLUSTRATIONS ATTRIBUTION next to the speedlo logo on desktop/tablet */}
      <Grid justifySelf={`flex-end`}>{isMinimal && !isMobile && <IllustrationsAttribution />}</Grid>
    </GridCentered>
  )
}
